export default "__VITE_ASSET__3075d650__"